import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        dark: true,
        colors: {
          // 브랜드 컬러 팔레트
          primary: '#a47864', // Mocha Mousse - 메인 포인트
          secondary: '#8ba475', // Tendrill
          accent: '#d19c97', // Rose Tan
          info: '#7391C8', // Cornflower Blue
          warning: '#a47864', // Mocha Mousse (warning도 브랜드 컬러로)
          error: '#d19c97', // Rose Tan
          success: '#8ba475', // Tendrill
          // 배경 색상
          surface: '#1e1e1e',
          background: '#0a0a0a',
          'black-card': '#2d2d2d',
          // 텍스트 색상
          'on-primary': '#ffffff',
          'on-secondary': '#ffffff',
          'on-surface': '#e0e0e0',
          'on-background': '#e0e0e0'
        }
      }
    }
  }
})
